import { StyleSheet } from 'aphrodite';
import { label, titles } from '../../../styles/colors';
import { cardStyle } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	card: {
		...cardStyle,
		boxSizing: 'border-box',
		color: label,
		display: 'flex',
		flexDirection: 'column',
		fontSize: 14,
		gap: 12,
		marginTop: 20,
		padding: '16px 20px',
	},
	title: {
		color: titles,
		fontSize: 14,
		fontWeight: 600,
	},
});
